import {Chip, List, ListItemButton, ListItemText, Typography} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {SidebarSection} from "./SidebarSection";

// one row of the warnings list.
export type SidebarWarning = {
    key: string;
    title: string;
    detail: string;
    // highlight the element the warning is about.
    onClick: () => void;
};

// a sidebar section headed "Warnings" with a count badge: a coloured number when there
// are warnings, grey when there are none. Opens to the list of warnings.
export function WarningsSection(props: {warnings: SidebarWarning[]}) {
    const count = props.warnings.length;

    return (
        <SidebarSection
            title="Warnings"
            icon={<WarningAmberIcon sx={{fontSize: 16, color: count > 0 ? "error.main" : "text.disabled"}} />}
            badge={
                <Chip
                    size="small"
                    label={count}
                    color={count > 0 ? "error" : "default"}
                    sx={{height: 18, fontSize: 11, "& .MuiChip-label": {px: 0.75}}}
                />
            }
        >
            {count === 0 && (
                <Typography color="text.secondary" variant="body2" sx={{px: 1.5, pb: 1}}>
                    No warnings.
                </Typography>
            )}
            {count > 0 && (
                <List dense disablePadding sx={{pb: 0.5}}>
                    {props.warnings.map(w => (
                        <ListItemButton key={w.key} onClick={w.onClick} sx={{py: 0.25, pl: 3}}>
                            <ListItemText
                                primary={w.title}
                                secondary={w.detail}
                                primaryTypographyProps={{variant: "body2"}}
                                secondaryTypographyProps={{variant: "caption"}}
                            />
                        </ListItemButton>
                    ))}
                </List>
            )}
        </SidebarSection>
    );
}
